import create from "zustand"

// export const blaaa = {}
const useStore = create((set, get) => ({
  // * LoadingBroadcaster
  visible: false,
  setVisible: v => set({ visible: v }),
  loaded: false,
  setLoaded: v => set({ loaded: v }),

  // * ActiveAptBroadcaster
  fullScreenPlan: false,
  setFullScreenPlan: v => set({ fullScreenPlan: v }),
  activeApt: null,
  setActiveApt: apt => set({ activeApt: apt }),

  // * FavouritestBroadcaster

  // favourites: [111, 127],
  favourites: [],
  setFavourites: favourites => set(() => ({ favourites })),
  addFavourite: id => set(state => ({ favourites: [...state.favourites, id] })),
  setFavouritesActive: active => set({ favouritesActive: active }),
  favouritesActive: false,
  removeFavourite: id =>
    set(state => ({
      favourites: state.favourites.filter(_id => _id !== id)
    })),

  selectedFavourite: null,
  setSelectedFavourite: favourite => set(() => ({ selectedFavourite: favourite })),

  // * PoiBroadcaster
  PoiActive: false,
  setPoiActive: active => set({ PoiActive: active }),
  poiID: "",
  setPoiID: id => set({ poiID: id }),

  // * CameraPosBroadcaster
  currentCameraPositionID: "blockE",
  setCurrentCameraPositionID: positionID => set({ currentCameraPositionID: positionID }),

  // * ActiveBlockBroadcaster
  activeBlock: null,
  setActiveBlock: block => set({ activeBlock: block }),
  // blockActive: () => set(state => state.activeBlock),

  // * ApartmentFinderBroadcaster
  apartmentFinderActive: false,
  setApartmentFinderActive: active => set({ apartmentFinderActive: active }),

  // * ActiveFloorBroadcaster
  activeFloor: null,
  setActiveFloors: f => set({ activeFloor: f }),

  // * FilterBroadcaster
  bedroomCounts: [],
  resetBedCounts: count =>
    set(state => ({
      bedroomCounts: []
    })),
  toggleBedroomCounts: count =>
    set(state => ({
      bedroomCounts: state.bedroomCounts.includes(count)
        ? state.bedroomCounts.filter(c => count !== c)
        : [...state.bedroomCounts, count]
    })),
  setBedroomCounts: counts =>
    set(() => ({
      bedroomCounts: counts
    })),
  bathroomCounts: [],
  resetBathroomCounts: count =>
    set(state => ({
      bathroomCounts: []
    })),
  toggleBathroomCounts: count =>
    set(state => ({
      bathroomCounts: state.bathroomCounts.includes(count)
        ? state.bathroomCounts.filter(c => count !== c)
        : [...state.bathroomCounts, count]
    })),
  setBathroomCounts: counts =>
    set(() => ({
      bathroomCounts: counts
    })),

  aspects: [],
  toggleAspect: aspect =>
    set(state => ({
      aspects: state.aspects.includes(aspect)
        ? state.aspects.filter(a => aspect !== a)
        : [...state.aspects, aspect]
    })),
  setAspects: aspects =>
    set(() => ({
      aspects: aspects
    })),

  // * ThreeSixtyBroadcaster
  viewID: false,
  setViewID: v => set({ viewID: v }),
  show360: false,
  setShow360: show360 => set(() => ({ show360, showRecipient360: false })),
  showRecipient360: false,
  setShowRecipient360: showRecipient360 => set(() => ({ showRecipient360 })),
  activeCard: false,
  setActiveCard: v => set({ activeCard: v }),
  openDlg: false,
  setOpenDlg: v => set({ openDlg: v }),
  showPano: false,
  setShowPano: v => set({ showPano: v }),
  index360: 0,
  setIndex360: v => set({ index360: v }),

  kView: "b",
  setKView: v => set({ kView: v }),

  // setActiveCard: show360 => set(() => ({ show360, showRecipient360: false })),
  // setActiveCard: v => set(() => ({  activeCard: v })),

  // * MapBroadcaster
  mapCategory: null,
  setMapCategory: category => set(() => ({ mapCategory: category })),
  mapLocation: null,
  setMapLocation: location => set(() => ({ mapLocation: location })),
  openSidebar: false,
  setOpenSidebar: v => set({ openSidebar: v }),
  openMapVideo: false,
  setOpenMapVideo: v => set({ openMapVideo: v }),
  openClockSidebar: false,
  setOpenClockSidebar: open => set(() => ({ openClockSidebar: open })),
  sidebarScrollPos: 0,
  setSidebarScrollPos: v => set({ sidebarScrollPos: v }),

  // * TwoDBroadcaster

  playingVideo: null,
  setPlayingVideo: playingVideo => set(() => ({ playingVideo })),
  tooltipVisible: true,
  setTooltipVisible: v => set(() => ({ tooltipVisible: v })),
  titleAnimate: "in",
  setTitleAnimate: v => set(() => ({ titleAnimate: v })),

  // * No Broadcast
  isShare: false,
  setIsShare: v => set({ isShare: v }),
  apartments: null,
  setApartments: apartments => set(() => ({ apartments })),

  setAll: incoming => set(state => ({ ...state, ...incoming }))
}))

export { useStore }
